import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {
      type: [String, Boolean]
    },
    label: {
      default: ''
    },
    removeMargin: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    confirmationRequired: {
      type: Boolean,
      default: false
    },
    confirmationModalProps: {
      default: () => {
        return {
          headerText: 'Please confirm',
          size: 'lg',
          bodyText: 'Are you sure you want to change the value?',
          cancelLabel: 'Cancel',
          saveLabel: 'Confirm',
          persistent: false
        };
      }
    }
  },
  emits: ['input', 'changed'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const showConfirmationModal = ref(false);
    const isChecked = ref(props.value);
    const openConfirmationModal = () => {
      showConfirmationModal.value = true;
    };
    const processUserConfirmation = proceed => {
      handleChange(proceed);
      showConfirmationModal.value = false;
    };
    const handleChange = event => {
      isChecked.value = !!event;
      emit('input', isChecked.value);
      emit('changed', isChecked.value);
    };
    watch(() => props.value, () => {
      isChecked.value = props.value === 'false' ? false : props.value;
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      props,
      showConfirmationModal,
      isChecked,
      emit,
      openConfirmationModal,
      processUserConfirmation,
      handleChange
    };
  }
});